import api from './baseApi';

export const getAssetHistoryByUserId = (userId, params) => api.get(`/assets/client/assetHistory/${userId}`, params);
export const getAllAssetsForClient = (params) => api.get('/assets/client/assets/all', params);
export const getPublicAssetCategories = () => api.get('/assets/client/categories/all');
export const postAssetRequest = (data) => api.post('/AssetRequests/client/requests/add', data);
export const getAssetHistory = (assetId) => api.get(`/assets/client/assetHistory/asset/${assetId}`);
export const getAssetRequests = (userId, params) => api.get(`/AssetRequests/client/requests/user/${userId}`, params);
export const cancelAssetRequest = (assetRequestId) => api.put(`/AssetRequests/client/requests/${assetRequestId}/cancel`);
